import { ROLE_LABEL } from "./role.helpers";
import type { Role } from "./api";

const ROLE_COLORS: Record<Role, string> = {
  supadmin: "bg-accent/20 text-accent-foreground",
  admin: "bg-secondary/15 text-secondary",
  manager: "bg-muted text-muted-foreground",
};

export function RoleBadge({ role }: { role: Role }) {
  return (
    <span
      className={`inline-flex rounded-full px-2 py-0.5 text-xs font-medium ${ROLE_COLORS[role]}`}
    >
      {ROLE_LABEL[role]}
    </span>
  );
}
